import { render, staticRenderFns } from "./SavedFilters.vue?vue&type=template&id=80a1eef8&"
import script from "./SavedFilters.vue?vue&type=script&lang=js&"
export * from "./SavedFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports